import * as React from 'react'
import { MenuListProps, components } from 'react-select'
import { PositionSelectOption } from '../position-select.types'

export const MenuList = (props: MenuListProps<PositionSelectOption, false>) => (
  <components.MenuList {...props} className="py-0" />
)
